import "./Carvejeira.module.css";
import Header from "@/reusable_sections/Header";
import Eurocontrol from "./sections/Eurocontrol";
import ContentShowcase from "./sections/ContentShowcase";
import Footer from "@/reusable_sections/Footer";
export default function CarvejeiraPage() {
  return <div>
      <Header />
      <Eurocontrol />
      <ContentShowcase />
      <Footer />
    </div>;
}